import React, { useState, useRef } from 'react';
import logo from '../AssetHeader/pplogo.svg';
import instalogo from '../AssetHeader/insta.svg';
import youtubelogo from '../AssetHeader/youtube.svg';
import facbooklogo from '../AssetHeader/facebook.svg';
import certificateImg from '../AssetHeader/certificate.png'; // Assuming your certificate image path
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [products, setProducts] = useState([
    {
      name: 'SME Insurance',
      expanded: false,
      subProducts: [
        { name: 'Group Health Insurance', url: '#' },
        { name: 'Cyber Insurance', url: '#' },
        { name: 'D&O Insurance', url: '#' },
        { name: 'Worker Compensation', url: '#' }
      ]
    },
    {
      name: 'Motor Insurance',
      expanded: false,
      subProducts: [
        { name: 'Car Insurance', url: 'https://www.policyplanner.com/Motor_Insurance/car-insurance.php' },
        { name: 'Bike Insurance', url: 'https://www.policyplanner.com/Motor_Insurance/bike-insurance.php' }
      ]
    },
    {
      name: 'Health Insurance',
      expanded: false,
      subProducts: [
        { name: 'Family Health Insurance', url: 'https://policyplanner.com/health-insurance.php' },
        { name: 'Parents Health Insurance', url: 'https://policyplanner.com/health-insurance.php' },
        { name: 'Individual Health Insurance', url: 'https://policyplanner.com/health-insurance.php' },
        { name: 'Maternity Health Insurance', url: 'https://policyplanner.com/health-insurance.php' },
        { name: 'Senior Citizen Insurance', url: 'https://policyplanner.com/health-insurance.php' }
      ]
    },
    {
      name: 'Term Insurance',
      expanded: false,
      subProducts: [
        { name: 'LIC Term Insurance', url: 'https://policyplanner.com/enquiry/term-insurance.php' },
        { name: 'Term Insurance vs ULIP', url: 'https://policyplanner.com/enquiry/term-insurance.php' },
        { name: 'Increasing Term Insurance', url: 'https://policyplanner.com/enquiry/term-insurance.php' },
        { name: 'Types of Death Covered', url: 'https://policyplanner.com/enquiry/term-insurance.php' },
        { name: 'Policy Period', url: 'https://policyplanner.com/enquiry/term-insurance.php' }
      ]
    },
    {
      name: 'Saving Plan',
      expanded: false,
      subProducts: [
        { name: 'Guaranteed Plans with immediate Returns', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Guaranteed Plans defer Returns', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Unit-linked investment plans', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Pension Plan with an immediate annuity', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Pension Plan with defer annuity', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Child Saving Plan', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Retirement Plan', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Tax Saving Investment', url: 'https://policyplanner.com/enquiry/saving-plan.php' },
        { name: 'Smart Deposit', url: 'https://policyplanner.com/enquiry/saving-plan.php' }
      ]
    },
    {
      name: 'Travel Insurance',
      expanded: false,
      subProducts: [
        { name: 'Get Travel Insurance', url: 'https://policyplanner.com/enquiry/form.php' },
        { name: 'Claim Travel Insurance', url: 'https://policyplanner.com/enquiry/form.php' },
        { name: 'Travel Insurance for Asia', url: 'https://policyplanner.com/enquiry/form.php' },
        { name: 'Travel Insurance Calculator', url: 'https://policyplanner.com/enquiry/form.php' },
        { name: 'Multiple Travel Insurance', url: 'https://policyplanner.com/enquiry/form.php' }
      ]
    }
  ]);
  const popupRef = useRef(null);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const closePopup = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      setIsPopupOpen(false);
    }
  };

  const toggleSubItems = (productName) => {
    const updatedProducts = products.map(product => {
      if (product.name === productName) {
        return { ...product, expanded: !product.expanded };
      } else {
        return product;
      }
    });
    setProducts(updatedProducts);
  };

  return (
    <div className="container-fluid container-fluid-Footer" onClick={closePopup}>
      <div className="row mainrow">
        <div className="col-12 col-md-3">
          <div>
            <img src={logo} alt="Policy Planner Logo" />
          </div>
          <div className="para">
            Policy Planner provides insurance coverage for individuals and
            businesses, including health, term life, motor, and SME Insurance.
            Our team ensures high-quality service and professional support to
            meet your specific needs.
          </div>
        </div>
        <div className="col-12 col-md-3 product">
          <h4>Products</h4>
          <ul>
            {products.map((product, index) => (
              <li key={index} style={{ color: 'black' }}>
                <span onClick={() => toggleSubItems(product.name)}>
                  <li className={product.expanded ? 'minus-icon toggle-icon' : 'plus-icon toggle-icon'}></li>
                  {product.name}
                </span>
                {product.expanded && (
                  <ul>
                    {product.subProducts.map((subProduct, subIndex) => (
                      <li key={subIndex}>
                        <a href={subProduct.url} target="_blank" rel="noopener noreferrer">{subProduct.name}</a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="col-12 col-md-3">
          <h4>Company</h4>
          <ul className="list-unstyled">
            <li style={{ color: 'black' }}>About Us</li>
            <li style={{ color: 'black' }}>Blogs</li>
            {/* <li style={{ color: 'black' }} onClick={togglePopup}>
              <b className="underlined" style={{ cursor: 'pointer' }}>Registration No. 747</b>
            </li> */}
            <li style={{ color: 'black' }}>SiteMap</li>
            {/* <a href='https://play.google.com/store/apps/details?id=com.posp.policyplanner&pli=1'><li style={{ color: 'black' }}>Become a PoSP</li></a>  */}
            <li style={{ color: 'black' }}> <Link to="https://play.google.com/store/apps/details?id=com.posp.policyplanner&pli=1">Become a PoSP </Link></li>
          </ul>
        </div>
        <div className="col-12 col-md-3">
          <h4>Contact Us</h4>
          <ul className="list-unstyled">
            <li style={{ color: 'black' }}>18001200771</li>
            <li style={{ color: 'black' }}>7798612243</li>
            <li style={{ color: 'black' }}>support@policyplanner.com</li>
            <li className="social-icons">
              <a href='https://www.instagram.com/policyplanner.in/' target="_blank" rel="noopener noreferrer">
                <img src={instalogo} alt="Instagram" />
              </a>
              <a href='https://www.youtube.com/@PolicyPlanner' target="_blank" rel="noopener noreferrer">
                <img src={youtubelogo} alt="YouTube" />
              </a>
              <a href='https://www.facebook.com/policyplanner.in/' target="_blank" rel="noopener noreferrer">
                <img src={facbooklogo} alt="Facebook" />
              </a>

            </li>
          </ul>
        </div>
      </div>
      <div className="para2">
        <p>
          Policyplanner is registered as a Direct Broker |
          <b className="underlined" onClick={togglePopup}>Registration No. 747</b>,
          Valid till 24/06/2027, License category- Direct Broker
          <br />
          Policy Planner Office No. B-03, KPCT Mall, Near Vishal Mega Mart,
          Fatima Nagar, Wanawadi, Pune 411013.
        </p>
        <br />
        <p>
          Disclaimer: Insurance is the subject matter of solicitation. Visitors
          are hereby informed that their information submitted on the website
          may be shared with insurers. The product information for comparison
          displayed on this website is of the insurers with whom our company has
          an agreement. Product information is authentic and solely based on
          the information received from the Insurer.
        </p>
      </div>
      <div className="border"></div>
      <div className="last">
        <div>
          <b>© 2024, policyplanner.com</b>
        </div>
        <div className="bold">
          <b>Terms Of Use</b>
          <b>Privacy Policy</b>
        </div>
      </div>

      {/* Popup Component */}
      {isPopupOpen && (
        <>
          <div className="popup-overlay" onClick={togglePopup}></div>
          <div className="popup">
            <div className="popup-content" ref={popupRef}>
              <img
                src={certificateImg}
                alt="IRDA Certificate"
                className="popup-image"
                onClick={togglePopup}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Footer;

